import {downloadFile} from '@dms/shared';

export const downloadCsv = (urlData: string, fileName: string) =>
  downloadFile(`data:text/csv;charset=UTF-8,\uFEFF${encodeURIComponent(urlData)}`, {fileName});
